import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import { JobState } from '../reducers/job.reducer';

export const loadUnitDetailsState = createSelector(
    fromFeature.locumsFeature,
    (state: fromFeature.LocumsStoreState) => state.job
);

export const selectJobUnitDetails = createSelector(loadUnitDetailsState, (state: JobState) => state.unitDetails);
